const ChatReg = /[^\x00-\xff]/gi;
//区分中文和英文的长度，中文2，字母1
export const getByteLen = function (val) {
    let length = 0;
    for (let i = 0, len = val.length; i < len; i++) {
        let a = val.charAt(i);
        if (a.match(ChatReg) != null) {
            length += 2;
        }
        else {
            length += 1;
        }
    }
    return length;
}
//获取真实的长度
export const getRealLen = function (val, limit) {
    limit = limit * 2;
    let length = 0;
    let realLen;
    for (let i = 0, len = val.length; i < len; i++) {
        let a = val.charAt(i);
        if (length < limit) {
            if (a.match(ChatReg) != null) {
                length += 2;
            }
            else {
                length += 1;
            }
        }
        else {
            realLen = i;
            break;
        }
    }
    if (realLen) {
        if (length % 2 == 1) {
            realLen--;
        }
    }
    else {
        realLen = val.length;
    }
    return realLen;
}
/*
    处理分享数的显示 10万，1亿
    小于10w显示确数；
    大于等于10w小于1亿显示x.x万，如果小数点后为0，则直接显示整数；
    大于等于1亿显示x.x亿，如果小数点后为0，则直接显示整数。
*/
export const getMomCount = function (count) {
    count = count ? parseInt(count, 10) : 0;
    if (count >= 100000000) {
        return ((Math.floor(count / 10000000) / 10) + "亿");
    }
    else if (count >= 100000) {
        return ((Math.floor(count / 1000) / 10) + "万");
    }
    else {
        return count;
    }
}
/*
    过滤html标签
*/
const reg = /<\/?[^>]*>/gi;
export const filterHtml = function (str) {
    if (!str) {
        return '';
    }
    return str.replace(reg, function (str) {
        return '';
    });
}

const urlReg = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+/;
export const checkUrl = function (str) {
    return urlReg.test(str);
}
const Tool = {
    getByteLen,
    getRealLen,
    filterHtml,
    getMomCount,
    checkUrl
}

/**
 *  Luhn算法检验银行卡号
 * 
 * @param  {String} card_number [需要检验的卡号]
 * @return {Boolean}
 * 
 * @author tonyc726
 */
export function validate_card_luhn(card_number) {
    var str_digits = (card_number + '').replace(/[\D]/g, '');

    if (!/^\d{12,19}$/.test(str_digits)) {
        return false;
    }

    var luhn_digits = str_digits.split('').reverse(),
        luhn_checkcode = parseInt(luhn_digits.shift(), 10);

    var loop_length = luhn_digits.length,
        loop_index = loop_length;

    var luhn_sum = 0;
    for (; loop_index > 0; loop_index--) {
        var _i = loop_length - loop_index,
            _k = parseInt(luhn_digits[_i], 10);
        var _add_val = _k;
        if ((_i % 2) === 0) {
            var _k2 = _k * 2;
            switch (_k2) {
                case 10: _add_val = 1; break;
                case 12: _add_val = 3; break;
                case 14: _add_val = 5; break;
                case 16: _add_val = 7; break;
                case 18: _add_val = 9; break;
                default: _add_val = _k2;
            }
        }
        luhn_sum += _add_val;
    }
    var luhn_sum9 = luhn_sum * 9,
        luhn_sum9_last_code = parseInt((luhn_sum9 + '').replace(/\d+(\d$)/, '$1'), 10);
    return (luhn_sum9_last_code === luhn_checkcode);
}

//  属性相等
export function propEq(key, value) {
    return (obj) => {
        return obj && obj[key] === value;
    };
}

// 实名认证身份证校验
export function checkIDCard(id){
    var city = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    var pass= true;
    
    if(!id || !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(id)){
        pass = false;
    }else if(!city[id.substr(0,2)]){
        pass = false;
    }else{
        //18位身份证需要验证最后一位校验位
        if(id.length == 18){
            id = id.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            //校验位
            var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++)
            {
                ai = id[i];
                wi = factor[i];
                sum += ai * wi;
            }
            let id17 = id[17];
            if(id17 === 'x'){
                id17 = 'X';
            }
            if(parity[sum % 11] != id17){
                pass =false;
            }
        }
    }
    return pass;
}

export const checkPhone = function(value){
    value = (value || "").trim();
    const PhoneRegEx = /^1\d{10}$/;
    return PhoneRegEx.test(value)

}

export const checkChinese = function(value){
    const ChineseRegx = /([^\u0000-\u00FF])/g;
    return ChineseRegx.test(value)
}


export const checkEmail = function (value = '') {
  value = (value || "").trim();
  const EMailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return EMailRegEx.test(value);
}

export const checkQQ = function (value = '') {
  value = (value || "").trim();
  const QQRegEx = /^[1-9]\d{4,}$/; //QQ位数大于4位，最多多少位不知道
  return QQRegEx.test(value);
}

export const checkWeChat = function (value = '') {
  // 微信账号仅支持6-20个字母、数字、下划线或减号，以字母开头。
  value = (value || "").trim();
  const WeChatRegEx = /^[a-zA-Z]{1}[a-zA-Z\d_-]{5,19}$/;
  return WeChatRegEx.test(value);
};

export const getReadCount = function (count = 0, language) {
    if (count >= 100000000) {
        return `${Math.floor(count / 10000000) / 10}亿`;
    }
    if (count >= 10000) {
        return (`${(count / 10000).toFixed(1)}${language === 'cn' ? '万' : 'w'}`);
    }

    return count;
};



// WEBPACK FOOTER //
// ./client/util/tool.js